import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { Checkbox as Component } from 'antd';

const Checkbox = styled(forwardRef(({ fillColor, ...props }, ref) => <Component {...props} ref={ref} />))`
  font-size: 16px;

  .ant-checkbox-inner,
  .ant-checkbox,
  .ant-checkbox:hover {
    border-radius: 4px !important;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #137ac9;
    border-color: #137ac9;
    ${props =>
      props.fillColor &&
      css`
        border-color: ${props.fillColor};
        background-color: ${props.fillColor};
      `}
  }

  &:hover .ant-checkbox:not(.ant-checkbox-checked) .ant-checkbox-inner {
    border-color: #e0e0e0 !important;
    background: #efefef !important;
    border-radius: 4px !important;
  }

  span:last-child {
    word-break: break-word;
  }
`;
Checkbox.Group = Component.Group;

/** @component */
export default Checkbox;
